import defaultList from "./defaultList";

const state = {
  listPictures: [{ ...defaultList }],

  pictureDetails: {
    artist: null,
    character: null,
    id: null,
    pixiv_id: null,
    source: {
      category: null,
      resolution: null,
      purity: null,
      url: null,
    },
    tags: null,
  },
};

export default state;
